
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1513 -6037)"}},[_c('circle',{attrs:{"data-name":"Ellipse 298","cx":"22","cy":"22","r":"22","transform":"translate(1513 6037)","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 2780","d":"M1549.867 6050.228a11.077 11.077 0 01-3.182.875 5.57 5.57 0 002.442-3.07 11.114 11.114 0 01-3.525 1.346 5.556 5.556 0 00-9.46 5.064 15.759 15.759 0 01-11.443-5.8 5.557 5.557 0 001.724 7.413 5.512 5.512 0 01-2.52-.695v.07a5.554 5.554 0 004.454 5.438 5.57 5.57 0 01-2.507.1 5.557 5.557 0 005.186 3.855 11.207 11.207 0 01-8.223 2.3 15.783 15.783 0 0024.3-13.293c0-.24 0-.48-.016-.718a11.258 11.258 0 002.771-2.873z"}})])])
          )
        }
      }
    